// extracted by mini-css-extract-plugin
export var numpadContainer = "_nf-1";
export var phoneButton = "_nf-0";